import { highlightedLayerIdAtom, selectedLayerIdAtom } from '../atoms'
import { FOCUSABLE_LAYER_TYPES } from './constants'
import { GizmoBox } from './gizmo-box'
import { GizmoQuickTools } from './quick-tools'

export function LayerGizmo() {
	return (
		<>
			<GizmoBox
				layerIdAtom={selectedLayerIdAtom}
				border="2px solid #3b82f6"
				typeFilter={FOCUSABLE_LAYER_TYPES}
				showBoxModel
				showResizeHandles
				showDragOverlay
			/>
			<GizmoBox layerIdAtom={highlightedLayerIdAtom} border="2px dashed #3b82f6" hideWhenSelected />
			<GizmoQuickTools />
		</>
	)
}
